module.exports = __webpack_public_path__ + "img/1505838951.ed3da489.jpg";